import {loadingOverlayActions, notifsActions} from "../index";
import {createMessageRequestException} from "../../fanctionUtility";
import new_axios_instance from '../../axios_instance';

/**
 * Ricerca paginata delle timbrature eliminate (solo admin).
 * Ritorna la Promise axios: la gestione del risultato avviene nel container.
 */
export const ricercaTimbratureEliminate = (params) => {
    return new_axios_instance.post(`/v1/timbratura/eliminate/ricerca`, params);
};

/**
 * Ripristina una timbratura eliminata. Il ripristino è consentito dal backend
 * solo se il mese di riferimento non è validato: in caso contrario viene
 * mostrato il messaggio di errore restituito.
 */
export const ripristinaTimbratura = (id, onSuccess) => async dispatch => {
    dispatch(loadingOverlayActions.showLoadingOverlay());
    await new_axios_instance.post(`/v1/timbratura/eliminate/ripristina/${id}`)
        .then(() => {
            dispatch(notifsActions.notifSuccess(`Timbratura ripristinata con successo`));
            dispatch(loadingOverlayActions.hideLoadingOverlay());
            if (typeof onSuccess === 'function') {
                onSuccess();
            }
        })
        .catch(error => {
            const message = createMessageRequestException(error);
            dispatch(notifsActions.notifError(message));
            dispatch(loadingOverlayActions.hideLoadingOverlay());
        });
};
